import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { IncludedSection } from '../components/IncludedSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#0a0a0a] text-white" data-id="element-166">
      <Hero data-id="element-167" />
      <ProblemSection data-id="element-168" />
      <SolutionSection data-id="element-169" />
      <BenefitsSection data-id="element-170" />
      <IncludedSection data-id="element-171" />
      <PricingSection data-id="element-172" />
      <Footer data-id="element-173" />
    </main>;
}